import React, { useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";

const Navbar = ({ user }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    signOut(auth);
  };

  const fullName = user?.displayName || `${user.firstName || ""} ${user.lastName || ""}`.trim();

  return (
    <>
      <div className="flex items-center justify-between px-4 py-4 bg-zinc-800 text-white">
        <h1 className="text-lg font-semibold">Inventory</h1>

        {user && (
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="z-50 w-8 h-8 flex flex-col justify-center items-center space-y-[5px]"
          >
            <span
              className={`w-6 h-[2px] bg-gray-200 transition-transform duration-300 ${menuOpen ? "rotate-45 translate-y-[6px]" : ""
                }`}
            />
            <span
              className={`w-6 h-[2px] bg-gray-200 transition-opacity duration-300 ${menuOpen ? "opacity-0" : ""
                }`}
            />
            <span
              className={`w-6 h-[2px] bg-gray-200 transition-transform duration-300 ${menuOpen ? "-rotate-45 -translate-y-[6px]" : ""
                }`}
            />
          </button>
        )}
      </div>

      {/* Sliding Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-zinc-900 text-white shadow-lg transform transition-transform duration-300 z-40 ${menuOpen ? "translate-x-0" : "translate-x-full"
          }`}
      >
        <div className="flex flex-col h-full justify-between">
          <div className="p-6 space-y-4">
            <button
              className="w-full text-left py-2 hover:text-gray-300"
              onClick={() => {
                navigate("/inventory?view=front");
                setMenuOpen(false);
              }}
            >
              Front Inventory
            </button>
            <button
              className="w-full text-left py-2 hover:text-gray-300"
              onClick={() => {
                navigate("/inventory?view=back");
                setMenuOpen(false);
              }}
            >
              Back Inventory
            </button>
            <button
              className="w-full text-left py-2 hover:text-gray-300"
              onClick={() => {
                navigate("/inventory/onhold");
                setMenuOpen(false);
              }}
            >
              On Hold
            </button>
            <button
              className="w-full text-left py-2 hover:text-gray-300"
              onClick={() => {
                navigate("/cases");
                setMenuOpen(false);
              }}
            >
              Cases location
            </button>
            <button
              className="w-full text-left py-2 hover:text-gray-300"
              onClick={() => {
                navigate("/logs");
                setMenuOpen(false);
              }}
            >
              History
            </button>

            <button
              className="w-full text-left py-2 hover:text-gray-300"
              onClick={() => {
                navigate("/cartier");
                setMenuOpen(false);
              }}
            >
              Cartier
            </button>

          </div>

          <div className="p-6 border-t border-gray-700">
            <p className="text-sm mb-2">👤 {fullName}</p>
            <button
              onClick={handleLogout}
              className="w-full bg-red-600 hover:bg-red-700 py-2 text-sm rounded"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
